const BaseCategoryPage = require('base/category-page');
const Server = require('helper/server');
const { walkNoTextTree } = require('helper/util');
// const { districtCode } = require('helper/config');
// const { searchAgencyAndSupplier } = require('helper/search');

const listTpl = Handlebars.templates['templates/activity-list-tpl'];

class OrgCategory extends BaseCategoryPage {
  constructor () {
    super({
      events: {
        'click .js-status': 'statusChanged'
      }
    });
    this.$activityStatus = $('.js-status');
    this.status = '';
    this.pageSize = 10;
  }

  statusChanged (e) {
    const $this = $(e.target);
    $this.siblings().each((index, item) => {
      $(item).removeClass('selected');
    });
    $this.addClass('selected');
    console.log($this.data('status'));
    this.status = $this.data('status');
    this.search();
  }

  search () {
    // searchAgencyAndSupplier.apply(this);
    this.$content.find('.block__content').spin(); // 搜索前先旋转
    const requestData = {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      homePageSearch: 1,
      status: this.status,
      name: this.query && this.query.params && this.query.params.keyword || ''
    };
    console.log('request data:', requestData);
    this.renderActivityList(requestData);
    // const { code, text } = this.selectedTreeNode;
    // // 两种情况:代理机构列表、供应商列表
    // if (this.rootType.includes('代理机构')) {
    //   const requestData = {
    //     pageNo: this.pageNo,
    //     pageSize: this.pageSize,
    //     regDist: code
    //   };
    //   if (this.query.get('keyword')) {
    //     requestData.fullName = this.query.get('keyword');
    //   }
    //   this.renderAgentList(requestData);
    // } else {
    //   const requestData = {
    //     pageNo: this.pageNo,
    //     pageSize: this.pageSize,
    //     district: districtCode
    //   };
    //   switch (text) {
    //     case '公示中':
    //       requestData.auditStatus = 'PUBLIC_COMMENT';
    //       break;
    //     case '待入库':
    //       requestData.auditStatus = 'PUBLIC_COMMENT_END';
    //       break;
    //     default:
    //       requestData.status = 'OFFICIAL';
    //       break;
    //   }

    //   if (this.query.get('keyword')) {
    //     requestData.name = this.query.get('keyword');
    //   }
    //   this.renderSupplierList(requestData);
    // }
  }

  // renderAgentList (payload) {
  //   const { articleModelFile } = super.treeData();
  //   Server.getAgentList({ data: payload })
  //     .done(({ total = 0, data = [] }) => {
  //       if (data && data instanceof Array) {
  //         data.forEach((item, index) => {
  //           item.index = index + 1;
  //         });
  //       }
  //       this.$content.find('.block__content').html(agentListTpl({
  //         _DATA_: data,
  //         _pageSize_: this.pageSize || '15',
  //         _PATH_: articleModelFile
  //       }));
  //       this.$el.find('.block__content .total').text(total || 0);
  //       this.initPagination(total);
  //     });
  // }

  renderActivityList (payload) {
    const { articleModelFile } = super.treeData();
    // Server.getSupplierList({ data: payload })
    //   .done(({ total = 0, data = [] }) => {
    //     if (data && data instanceof Array) {
    //       data.forEach((item, index) => {
    //         item.index = index + 1;
    //       });
    //     }
    //     this.$content.find('.block__content').html(supplierListTpl({
    //       _DATA_: data,
    //       _pageSize_: this.pageSize || '15',
    //       _PATH_: articleModelFile
    //     }));
    //     this.$el.find('.block__content .total').text(total || 0);
    //     this.initPagination(total);
    //   });
    Server.getActivityList(payload).then(({ total, data }) => {
      let _DATA_ = data && data.map(item => ({
        ...item,
        activityTime: item.activityTime || '待定',
        shortBriefInfo: item.briefInfo.length > 138 ? item.briefInfo.slice(0, 135) + '...' : item.briefInfo
      }));
      $('.block__content').html(listTpl({
        _DATA_,
        _TOTAL_: total,
        _pageSize_: this.pageSize
      }));
      // pagination-container
      // if (!total) {
      //   $('.pagination-container').addClass('hide');
      // } else {
      //   $('.pagination-container').removeClass('hide');
      // }
      this.$el.find('.block__content .total').text(total || 0);
      this.initPagination(total);
    });
  }

  selectTreeNode (e, { instance }) {
    this.renderBreadcrumb(instance);
    this.$content.find('.block__content').spin();
    this.search();
  }
}

module.exports = OrgCategory;
